(() => {
  const prefix = 'salibay-product-page:v1:';
  function localUrl(product) {
    if (product.routeType !== 'local' && product.ribbonLabel !== 'Local Ready') return null;
    try {
      const url = new URL(product.productUrl || '', location.origin);
      return url.origin === location.origin && url.pathname.startsWith('/products/') ? url.pathname + url.search : null;
    } catch (_) { return null; }
  }
  function remember(product,context={}) {
    const saved={...product,navigationQuery:context.query || product.navigationQuery || product.title,navigationPage:context.page || product.navigationPage || 1,navigationMarket:context.market || product.navigationMarket || ''};
    try { sessionStorage.setItem(prefix+product.publicId,JSON.stringify({at:Date.now(),product:saved})); } catch (_) {}
    return saved;
  }
  function url(product,context={}) {
    const local=localUrl(product);
    if (local) return local;
    const params=new URLSearchParams({view:'global-product',id:product.publicId,q:context.query || product.navigationQuery || product.title || '',source_page:String(context.page || product.navigationPage || 1)});
    const market=context.market || product.navigationMarket;
    if (market) params.set('market',market);
    return '/search?'+params;
  }
  window.SalibayProductNavigation={url,remember,read(id){try {const cached=JSON.parse(sessionStorage.getItem(prefix+id)||'null');return cached && Date.now()-cached.at<1800000 ? cached.product : null;}catch(_){return null;}},open(product,context={}){remember(product,context);location.assign(url(product,context));}};
})();
